import { render, staticRenderFns } from "./CPPPurchase.vue?vue&type=template&id=3fb10849&scoped=true"
import script from "./CPPPurchase.vue?vue&type=script&lang=js"
export * from "./CPPPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb10849",
  null
  
)

export default component.exports